import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingState } from '../../../core/panels/loading-panel.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { EmptyStateComponent } from '../../../core/panels/empty-state.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';
import { ClaimBillDetail } from '../../../../models/api/view/claim/financials/bills/claim-bill-detail';

@Component({
  selector: 'app-bill-info-section',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    DetailPanelComponent,
    DetailItemComponent,
    EmptyStateComponent,
    ProgressbarComponent,
  ],
  template: `
    <app-card label="Bill/Invoice information">
      @if (state === 'Loading') {
        <app-empty-state
          height="200px"
          icon="fa-light fa-file-invoice"
          label="Loading bill information"
          message="Retrieving from bill repository"
        >
          <div class="tw-py-4">
            <app-progressbar />
          </div>
        </app-empty-state>
      } @else {
        @if (transformedBillItem) {
          <div class="tw-flex">
            <div class="tw-basis-1/3 tw-pr-8">
              <app-detail-panel [dataSource]="transformedBillItem">
                <app-detail-item label="Bill status" name="billStatus" />
                <app-detail-item label="Vendor code" name="vendorId" />
                <app-detail-item label="Review only" name="reviewOnly" />
                <app-detail-item label="Review fee" name="reviewFee" />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3 tw-pr-8">
              <app-detail-panel [dataSource]="transformedBillItem">
                <app-detail-item
                  label="Internal control number"
                  labelCase="none"
                  name="icn"
                />
                <app-detail-item label="Vendor name" name="vendorName" />
                <app-detail-item label="Denial" name="denied" />
                <app-detail-item
                  label="PPO fee"
                  name="ppoFee"
                  labelCase="none"
                />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3 tw-pr-8">
              <app-detail-panel [dataSource]="transformedBillItem">
                <app-detail-item label="Invoice" name="invoice" />
                <app-detail-item label="DCN" name="dcn" labelCase="none" />
                <app-detail-item
                  label="SIR DCN"
                  name="sirDcn"
                  labelCase="none"
                />
                <app-detail-item label="Nurse fee" name="nurseFee" />
              </app-detail-panel>
            </div>
          </div>
        }
      }
    </app-card>
  `,
})
export class BillInfoSectionComponent {
  @Input() billItem: ClaimBillDetail | null = null;
  @Input() state: LoadingState = 'Loading';

  /**
   * Transform billItem with converted Y/N values to Yes/No
   */
  get transformedBillItem() {
    if (!this.billItem) {
      return null;
    }

    return {
      ...this.billItem,
      reviewOnly: this.convertYesNo(this.billItem.reviewOnly),
      denied: this.convertYesNo(this.billItem.denied),
    };
  }

  /**
   * Convert Y/N characters to Yes/No strings (case-insensitive)
   */
  private convertYesNo(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return value.toUpperCase() === 'Y' ? 'Yes' : 'No';
  }
}
